import React from "react";
import { Link } from "react-router-dom";
import "./IconsRow.css";

import icon1 from "./assets/icons/accessorie.png";
import icon2 from "./assets/icons/bag.png";
import icon3 from "./assets/icons/candle.png";
import icon4 from "./assets/icons/carpet.png";
import icon5 from "./assets/icons/clothing.png";
import icon6 from "./assets/icons/curtain.png";
import icon7 from "./assets/icons/ghalam.png";
import icon8 from "./assets/icons/needlework.png";
import icon9 from "./assets/icons/painting.png";
import icon10 from "./assets/icons/rugonpot.png";
import icon11 from "./assets/icons/turqoise.png";



const IconsRow = () => {
  const icons = [
    { src: icon11, label: "ظروف فیروزه‌کوبی", link: "products/turquoise-copper-dishes" },
    { src: icon7, label: "ظروف قلم‌زنی", link: "products/ghalamzani-dishes-art" },
    { src: icon4, label: "فرش دست‌‌بافت", link: "products/carpet" },
    { src: icon2, label: "کیف و کوله", link: "products/bags-backpacks" },
    { src: icon5, label: "لباس محلی", link: "products/lebas-mahali" },
    { src: icon10, label: "گلیم روی سفال", link: "products/gilim-on-sofal" },
    { src: icon1, label: "اکسسوری", link: "products/accessories" },
    { src: icon3, label: "انواع شمع", link: "products/types-of-candles" },

  ];

return (
  <div className="icons-row">
    {icons.map((icon, index) => (
      <Link to={icon.link} key={index} className="icon-wrapper">
        <img src={icon.src} alt={icon.label} className="icon-item" />
        <p className="icon-label">{icon.label}</p>
      </Link>
    ))}
  </div>
);
};

export default IconsRow;
